import { reducerWithInitialState } from "typescript-fsa-reducers";
import { EntitiesMap, CompanyPostPin } from "../entities";
import { mergeEntities } from "../../lib/entities";
import {
  bootstrapCompanyShow,
  loadCompanyShow,
  bootstrapCompanyAbout,
  loadCompanyAbout,
  bootstrapCompanyMembers,
  loadCompanyMembers,
  bootstrapCompanyPosts,
  loadCompanyPosts,
  bootstrapCompanyProjects,
  loadCompanyProjects,
  loadSimilarCompanies,
  loadNextPosts,
  loadPinnablePosts,
  likePost,
  unlikePost,
  saveDraftCompany,
  saveDraftCompanyValues,
  saveDraftCompanyMemberships,
  loadInvisibleCompanyValues,
  sendCompanyPost,
  saveDraftPostPins,
} from "../actions";

const entitiesReducer = reducerWithInitialState<EntitiesMap>({
  companies: {},
  users: {},
  profiles: {},
  images: {},
  projects: {},
  posts: {},
  post_spaces: {},
  company_post_pins: {},
  portfolio_projects: {},
  company_memberships: {},
  company_membership_sections: {},
  company_values: {},
  company_value_features: {},
  company_followings: {},
})
  .cases(
    [
      bootstrapCompanyShow,
      bootstrapCompanyAbout,
      bootstrapCompanyMembers,
      bootstrapCompanyPosts,
      bootstrapCompanyProjects,
    ],
    (state, { entities }) => {
      return mergeEntities(state, entities);
    }
  )
  .cases(
    [
      loadCompanyShow.done,
      loadCompanyAbout.done,
      loadCompanyMembers.done,
      loadCompanyPosts.done,
      loadCompanyProjects.done,
      loadSimilarCompanies.done,
      loadNextPosts.done,
      loadPinnablePosts.done,
      loadInvisibleCompanyValues.done,
      sendCompanyPost.done,
    ],
    (state, { result }) => {
      return mergeEntities(state, result.entities);
    }
  )
  .case(likePost.started, (state, post) => {
    return mergeEntities(state, {
      posts: {
        [post.id]: {
          liked_status: {
            state: true,
          },
        },
      },
    });
  })
  .case(unlikePost.started, (state, post) => {
    return mergeEntities(state, {
      posts: {
        [post.id]: {
          liked_status: {
            state: false,
          },
        },
      },
    });
  })
  .case(likePost.failed, (state, { params: post }) => {
    return mergeEntities(state, {
      posts: {
        [post.id]: {
          liked_status: {
            state: false,
          },
        },
      },
    });
  })
  .case(unlikePost.failed, (state, { params: post }) => {
    return mergeEntities(state, {
      posts: {
        [post.id]: {
          liked_status: {
            state: true,
          },
        },
      },
    });
  })
  .cases(
    [saveDraftCompany.done, saveDraftCompanyValues.done, saveDraftCompanyMemberships.done],
    (state, { result: { entities } }) => {
      return mergeEntities(state, entities);
    }
  )
  .case(saveDraftPostPins.done, (state, { result: pins }) => {
    return mergeEntities(state, {
      company_post_pins: pins.reduce(
        (acc, pin) => {
          acc[pin.id] = pin;
          return acc;
        },
        {} as { [key: string]: CompanyPostPin }
      ),
    });
  });

export default entitiesReducer;



// WEBPACK FOOTER //
// ./frontend/src/companies/reducers/entities.ts